export default {
  'actions.login': 'התחברות',
  'actions.logout': 'התנתקות',
  'actions.register': 'הרשמה',
  'actions.resetPassword': 'איפוס סיסמה',
  'actions.sendVerificationEmail': 'שלח אימייל אימות',
  'actions.verifyEmail': 'אמת אימייל',
  'actions.create': 'צור',
  'actions.view': 'הצג',
  'actions.viewAll': 'הצג הכל',
  'actions.viewDetails': 'הצג פרטים',
  'actions.assign': 'הקצה',
  'actions.unAssign': 'בטל הקצאה',
  'actions.assignAll': 'הקצה הכל',
  'actions.unAssignAll': 'בטל את כל ההקצאות',
  'actions.unassigned': 'לא מוקצה',
  'actions.generate': 'צור',
  'actions.manage': 'נהל',
  'actions.change': 'שנה',
  'actions.sendMessage': 'שלח',
  'actions.sort': 'מיין',
  'actions.ok': 'אישור',
  'actions.publish': 'פרסם',
  'actions.refresh': 'רענן',
  'actions.draft': 'טיוטה',
  'actions.hide': 'הסתר {{type}}',
  'actions.unHide': 'הצג {{type}}',
  'actions.like': 'אהבתי',
  'actions.unLike': 'בטל לייק',
  'actions.more': 'עוד',
  'actions.time': 'זמן',
  'actions.share': 'שתף',
  'actions.shareOn': 'שתף ב־{{type}}',
  'actions.export': 'ייצא',
  'actions.edit': 'ערוך {{type}}',
  'actions.show': 'הצג {{type}}',
  'actions.showOnMap': 'הצג במפה',
  'actions.download': 'הורד קובץ',
  'actions.exportAs': 'ייצא כ־{{type}}',
  'actions.email': 'שלח אימייל',
  'actions.copy': 'העתק',
  'actions.copied': 'הועתק',
  'actions.save': 'שמור',
  'actions.activate': 'הפעל',
  'actions.deactivate': 'השבת',
  'actions.preview': 'תצוגה מקדימה',
  'actions.hold': 'השהה',
  'actions.delete': 'מחק',
  'actions.deleteEntity': 'מחק {{type}}',
  'actions.update': 'עדכן',
  'actions.upload': 'העלה',
  'actions.reload': 'טען מחדש',
  'actions.screenshot': 'צילום מסך',
  'actions.views': 'צפיות',
  'actions.close': 'סגור',
  'actions.confirm': 'אשר',
  'actions.add': 'הוסף {{type}}',
  'actions.back': 'חזור',
  'actions.cancel': 'ביטול',
  'actions.select': 'בחר',
  'actions.unselect': 'בטל בחירה',
  'actions.setAs': 'הגדר כ־{{type}}',
  'actions.search': 'חיפוש',
  'actions.new': 'חדש',
  'actions.next': 'הבא',
  'actions.prev': 'הקודם',
  'actions.yes': 'כן',
  'actions.no': 'לא',
  'actions.leave': 'עזוב',
  'actions.stay': 'הישאר',
  'actions.clone': 'שכפל',
  'actions.cloneEntity': 'שכפל {{type}}',
};
